export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/mike-aab414f7b69d0d4ad897e75e735f240a.jpg";